import { SyncTimestampState } from "../actions/types";

const INITAL_STATE = {}

export default (state = INITAL_STATE, action: { type: string, payload: SyncTimestampState }) => {
  switch (action.type) {
    case "TIME_UPDATE":
      return { ...state, ...action.payload  };
    default:
      return state;
  }
}
